'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _fastDeepEqual = require('fast-deep-equal');

var _fastDeepEqual2 = _interopRequireDefault(_fastDeepEqual);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _form = require('../form');

var _form2 = _interopRequireDefault(_form);

var _formInput = require('../../../molecules/forms/formInput');

var _formInput2 = _interopRequireDefault(_formInput);

var _formDropdown = require('../../../molecules/forms/formDropdown');

var _formDropdown2 = _interopRequireDefault(_formDropdown);

var _formSwitch = require('../../../molecules/forms/formSwitch');

var _formSwitch2 = _interopRequireDefault(_formSwitch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddressForm = function AddressForm(props) {
    var initialAddress = props.address,
        validationInfo = props.validationInfo,
        pageCode = props.pageCode,
        sectionCode = props.sectionCode,
        rowId = props.rowId,
        saveTooltipInfo = props.saveTooltipInfo,
        reduceTooltipInfoElement = props.reduceTooltipInfoElement,
        tooltipInfo = props.tooltipInfo,
        header = props.header,
        label = props.label,
        saveEvent = props.saveEvent,
        cancelEvent = props.cancelEvent,
        allowEdit = props.allowEdit,
        alwaysEditing = props.alwaysEditing,
        enableAddressSearch = props.enableAddressSearch,
        addressSearchCountryCode = props.addressSearchCountryCode,
        _changeEvent = props.changeEvent,
        reference = props.reference,
        intl = props.intl;

    var _useState = (0, _react.useState)(null),
        _useState2 = _slicedToArray(_useState, 2),
        searchAddress = _useState2[0],
        setSearchAddress = _useState2[1];

    var _useState3 = (0, _react.useState)('GMAPS'),
        _useState4 = _slicedToArray(_useState3, 2),
        mode = _useState4[0],
        setMode = _useState4[1];

    var _useState5 = (0, _react.useState)([]),
        _useState6 = _slicedToArray(_useState5, 2),
        stateErrors = _useState6[0],
        setStateErrors = _useState6[1];

    var isEditableGoogle = (allowEdit || alwaysEditing) && mode === 'GMAPS';
    var isEditableManual = (allowEdit || alwaysEditing) && mode === 'MANUAL';

    (0, _react.useEffect)(function () {
        if (props.address) {
            setSearchAddress(initialAddress);

            if (props.address && props.address.code && props.address.code.includes('GMAPS')) {
                setMode('GMAPS');
            } else {
                setMode('MANUAL');
            }
        }

        if (!(0, _fastDeepEqual2.default)(props.address, searchAddress)) {
            setSearchAddress(props.address);
            if (mode === 'MANUAL') _changeEvent('formattedAddress', formatAddress());
        }
    }, [searchAddress, props.address]);

    (0, _react.useEffect)(function () {
        if (props.address) {
            var stateProvinceReferences = updateChildRef(reference.references['StateProvince'], props.address.countryCode || '');

            if (stateProvinceReferences && props.address.stateCode) {
                var stateExistsInNewCountry = stateProvinceReferences.some(function (ref) {
                    return ref.code === props.address.stateCode;
                });

                if (!stateExistsInNewCountry) {
                    setStateErrors([{ message: intl.formatMessage({ id: 'AddressForm.stateInvalidError' }) }]);
                    return;
                }
            }
        }

        setStateErrors([]);
    }, [props.address && props.address.countryCode, props.address && props.address.stateCode]);

    var formatAddress = function formatAddress() {
        var address = props.address;
        var formattedAddress = '';

        if (address) {
            if (address.apartmentSuite) formattedAddress += address.apartmentSuite + '-';
            if (address.streetNumber) formattedAddress += address.streetNumber + ' ';
            if (address.street) formattedAddress += address.street + ', ';
            if (address.city) formattedAddress += address.city + ', ';
            if (address.stateCode) formattedAddress += address.stateCode + ' ';
            if (address.postalCode) formattedAddress += address.postalCode + ', ';
            if (address.country) formattedAddress += '' + address.country;

            // Remove leading and trailing spaces and commas
            formattedAddress = formattedAddress.trim().replace(/(^,)|(,$)/g, '');
        }

        return formattedAddress;
    };

    var updateChildRef = function updateChildRef(childRef, code) {
        var ref = childRef;

        if (code && ref) {
            ref = ref.filter(function (x) {
                return x.elements[0].value === code;
            });
        }

        return ref;
    };

    var switchChangeHandler = function switchChangeHandler(value) {
        setMode(value ? 'GMAPS' : 'MANUAL');
        if (value) {
            _changeEvent('code', 'GMAPS');
        } else {
            _changeEvent('code', 'MANUAL');
        }
        _changeEvent('formattedAddress', '');
        _changeEvent('apartmentSuite', '');
        _changeEvent('streetNumber', '');
        _changeEvent('street', '');
        _changeEvent('city', '');
        _changeEvent('state', '');
        _changeEvent('stateCode', '');
        _changeEvent('country', '');
        _changeEvent('countryCode', '');
        _changeEvent('postalCode', '');
        _changeEvent('location', {
            lat: '',
            lng: ''
        });
    };

    return _react2.default.createElement(
        _form2.default,
        {
            validationInfo: validationInfo,
            pageCode: pageCode,
            sectionCode: sectionCode,
            rowId: rowId,
            saveTooltipInfo: saveTooltipInfo,
            reduceTooltipInfoElement: reduceTooltipInfoElement,
            tooltipInfo: tooltipInfo,
            header: header,
            label: label,
            saveEvent: saveEvent,
            cancelEvent: cancelEvent,
            allowEdit: allowEdit,
            alwaysEditing: alwaysEditing,
            validate: function validate() {
                return !stateErrors.length;
            }
        },
        _react2.default.createElement(_formSwitch2.default, {
            label: intl.formatMessage({ id: 'AddressForm.addressAutofill' }),
            value: mode === 'GMAPS',
            changeEvent: switchChangeHandler,
            allowEdit: true
        }),
        enableAddressSearch && _react2.default.createElement(_formInput2.default, _extends({}, props, {
            fieldCode: 'searchAddress',
            label: intl.formatMessage({ id: 'AddressForm.searchAddress' }),
            placeholder: intl.formatMessage({ id: 'AddressForm.searchAddressPlaceholder' }),
            value: props.address && props.address.formattedAddress ? props.address.formattedAddress : '',
            address: props.address,
            countryCode: addressSearchCountryCode,
            changeEvent: function changeEvent(code, value) {
                if (code === 'address') setSearchAddress(value);
            },
            allowEdit: isEditableGoogle,
            selectEvent: function selectEvent(value) {
                return _changeEvent('address', value);
            }
        })),
        _react2.default.createElement(_formInput2.default, {
            fieldCode: 'apartmentSuite',
            label: intl.formatMessage({ id: 'AddressForm.apt' }),
            value: props.address && props.address.apartmentSuite,
            changeEvent: function changeEvent(value) {
                return _changeEvent('apartmentSuite', value);
            },
            allowEdit: isEditableManual,
            type: 'text'
        }),
        _react2.default.createElement(_formInput2.default, {
            fieldCode: 'streetNumber',
            label: intl.formatMessage({ id: 'AddressForm.no' }),
            value: props.address && props.address.streetNumber,
            changeEvent: function changeEvent(value) {
                return _changeEvent('streetNumber', value);
            },
            allowEdit: isEditableManual,
            type: 'text'
        }),
        _react2.default.createElement(_formInput2.default, {
            fieldCode: 'street',
            label: intl.formatMessage({ id: 'AddressForm.street' }),
            value: props.address && props.address.street,
            changeEvent: function changeEvent(value) {
                return _changeEvent('street', value);
            },
            allowEdit: isEditableManual,
            type: 'text'
        }),
        _react2.default.createElement(_formInput2.default, {
            fieldCode: 'city',
            label: intl.formatMessage({ id: 'AddressForm.city' }),
            value: props.address && props.address.city,
            changeEvent: function changeEvent(value) {
                return _changeEvent('city', value);
            },
            allowEdit: isEditableManual,
            type: 'text'
        }),
        props.address && (props.address.countryCode === '' || props.address.countryCode === 'CAN' || props.address.countryCode === 'USA') ? _react2.default.createElement(_formDropdown2.default, {
            fieldCode: 'province',
            label: intl.formatMessage({ id: 'AddressForm.province' }),
            value: props.address && { code: props.address.stateCode, value: props.address.state },
            references: reference.references && updateChildRef(reference.references['StateProvince'], props.address.countryCode),
            referencesEvent: function referencesEvent() {
                return reference.doGetReferences('StateProvince');
            },
            changeEvent: function changeEvent(value) {
                _changeEvent('stateCode', value.code);
                _changeEvent('state', value.value);
            },
            allowEdit: isEditableManual,
            errors: stateErrors
        }) : _react2.default.createElement(_formInput2.default, {
            fieldCode: 'state',
            label: intl.formatMessage({ id: 'AddressForm.state' }),
            value: props.address && props.address.state,
            changeEvent: function changeEvent(value) {
                _changeEvent('stateCode', '');
                _changeEvent('state', value);
            },
            allowEdit: isEditableManual,
            type: 'text'
        }),
        _react2.default.createElement(_formDropdown2.default, {
            fieldCode: 'country',
            label: intl.formatMessage({ id: 'AddressForm.country' }),
            value: props.address && {
                code: props.address.countryCode,
                value: props.address.country
            },
            references: [{
                code: 'CAN',
                value: intl.formatMessage({ id: 'AddressForm.countries.canada' })
            }, {
                code: 'USA',
                value: intl.formatMessage({ id: 'AddressForm.countries.unitedStates' })
            }],
            changeEvent: function changeEvent(value) {
                _changeEvent('countryCode', value.code);
                _changeEvent('country', value.value);
            },
            allowEdit: isEditableManual
        }),
        _react2.default.createElement(_formInput2.default, {
            fieldCode: 'postalCode',
            label: intl.formatMessage({ id: 'AddressForm.postalCode' }),
            value: props.address && props.address.postalCode,
            changeEvent: function changeEvent(value) {
                return _changeEvent('postalCode', value);
            },
            allowEdit: isEditableManual,
            type: 'text'
        })
    );
};

AddressForm.propTypes = {
    address: _propTypes2.default.object,
    validationInfo: _propTypes2.default.object,
    pageCode: _propTypes2.default.string,
    sectionCode: _propTypes2.default.string,
    rowId: _propTypes2.default.string,
    saveTooltipInfo: _propTypes2.default.object,
    reduceTooltipInfoElement: _propTypes2.default.func,
    tooltipInfo: _propTypes2.default.object,
    header: _propTypes2.default.string,
    label: _propTypes2.default.string,
    saveEvent: _propTypes2.default.func,
    cancelEvent: _propTypes2.default.func,
    allowEdit: _propTypes2.default.bool,
    alwaysEditing: _propTypes2.default.bool,
    enableAddressSearch: _propTypes2.default.bool,
    addressSearchCountryCode: _propTypes2.default.string,
    changeEvent: _propTypes2.default.func,
    reference: _propTypes2.default.object
};

exports.default = (0, _reactIntl.injectIntl)(AddressForm);